import { Component, input, output } from "@angular/core";
import { IssueWithDetails } from "../../../../domains/assertionIssues/services/assertion-issues.service";

@Component({
  selector: "needs-attention-item",
  standalone: true,
  templateUrl: "./needs-attention-item.component.html",
  styleUrl: "./needs-attention-item.component.scss",
})
export class NeedsAttentionItemComponent {
  issueWithDetail = input.required<IssueWithDetails>();
  navToIssue = output<IssueWithDetails>();
}
